export enum BoardSortDirectionsEnum {
  ASC = 'asc',
  DESC = 'desc',
}
